import { RequestCheckQueryService } from "../../../services/request/RequestCheckQueryService";
import { RequestCheckModel } from "../../models/Request";
import { IQueryRequestCheckRepository } from "../../ports/request/IQueryRequestCheckRepository";
import Query from "../Query";

class RequestCheckQuery
  extends Query<RequestCheckModel>
  implements IQueryRequestCheckRepository
{
  constructor(public queryService: RequestCheckQueryService) {
    super(queryService);
  }
}

export default RequestCheckQuery;
